module.exports = __webpack_public_path__ + "static/sales-cycle-icon-c5f649299ae7315bcb925264a4c63466.png";